import { createMutationHook } from '~/shared/providers/api';

export const useDeleteTransportationTypeMutation = createMutationHook(
  'transportation.transportationTypeDelete',
  (params: { id: string }) => ({
    transportationTransportationTypeDelete: {
      __args: {
        id: params.id,
      },
    },
  }),
);
